import {useGrid} from "../../../common";
import {ActivityLogFormItem, ActivityLogListItem, getActivityLogService} from "./activityLogApi";

export default function useActivityLogList() {
  const service = getActivityLogService();
  const grid = useGrid<ActivityLogFormItem, ActivityLogListItem>({
    comaSeparatedSortPrarms: true,
    storageType: "urlParams",
    id: "activityLog",
    loadColumns: true,
    translationCategory: "activityLog",
    confirmAttribute: "description",
    ...service,
  });
  return {
    grid
  };
}